import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .text {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-align: center;
    color: ${colors.white};
    margin: 0 4px;
  }

  .line {
    width: 140px;
    height: 1px;
    background-color: ${colors.silver};
  }

  ${({ additionalstyle }) => additionalstyle};
`;
